import CustomDropdown from "../../CustomDropdown";
import { CustomSelect } from "../../CustomSelect";
// import { IoFilter } from "react-icons/io5";
import { RxCaretSort } from "react-icons/rx";
import { CaratRangeFilter, WeightRangeFilter } from "./FilterSliders";
import CustomMultiSelect from "../../CustomMultiSelect";
import CustomCheckbox from "../../radix/CustomCheckbox";
import Cookies from "js-cookie";
import useCategoriesCollections from "../../../helpers/useCategoriesCollections";
import { useRef } from "react";

// const theKey = Cookies.get("kalista-webtoken");

// const sortingOptions = [
//   { value: 1, label: "Newest First" },
//   { value: -1, label: "Oldest First" },
//   { value: 2, label: "Net Weight : (High to Low)" },
//   { value: -2, label: "Net Weight : (Low to High)" },
//   { value: 3, label: "Diamond Weight : (High to Low)" },
//   { value: -3, label: "Diamond Weight : (Low to High)" },
//   { value: 4, label: "Best Seller" },
// ];

const ShopTopActionFilter = ({
  // sortOrder,
  // setSortOrder,
  // setFilterModal,
  // selectedCategory,
  // setSelectedCategory,
  // selectedCollection,
  // setSelectedCollection,
  // productGram,
  // setProductGram,
  // productCarat,
  // setProductCarat,
  // setProductData,
  // setPageOffSet,
  // filterProducts,
  // resetFilters,
  // sendCustomData,
  // setSendCustomData,
  // getProducts,
  // pageOffSet,
}) => {
  // const firstChecked = useRef(false);
  // // get api data
  // const { categoryData, collectionData } = useCategoriesCollections();

  // const handleCategoryChange = (value) => {
  //   setProductData([]);
  //   setPageOffSet(1);
  //   setSelectedCategory(value);
  // };

  // const toggleCollectionOption = (value) => {
  //   setProductData([]);
  //   setPageOffSet(1);

  //   setSelectedCollection((prev) => {
  //     const normalizedPrev = Array.isArray(prev)
  //       ? prev.map(String)
  //       : [String(prev)];
  //     const newValue = String(value);

  //     return normalizedPrev.includes(newValue)
  //       ? normalizedPrev.filter((item) => item !== newValue)
  //       : [...normalizedPrev, newValue];
  //   });
  // };

  // const mapOptions = (data, valueKey, labelKey) =>
  //   data?.map((option) => ({
  //     value: String(option[valueKey]),
  //     label: option[labelKey],
  //   }));

  return (
    <>
      {/* {theKey && (
        <div className="shop-top-bar mt-40">
          <div className="filter_left_con">
            <CustomSelect
              options={mapOptions(
                categoryData?.Data,
                "GatiCategoryId",
                "DesgGroupName"
              )}
              placeholder="Select Category"
              value={String(selectedCategory)}
              onChange={handleCategoryChange}
            />
            <CustomMultiSelect
              placeholder="Select Collection"
              placeholderKey="Collection"
              customClass="collection_multiselect_filter"
              options={mapOptions(
                collectionData?.Data,
                "GatiCategoryId",
                "DesgGroupName"
              )}
              dropdownValue={selectedCollection}
              toggleCollectionOption={toggleCollectionOption}
            />
            <CustomDropdown
              trigger={`Weight (GM) ${productGram[0]}-${productGram[1]}`}
              customClass="weight_filter"
            >
              <WeightRangeFilter
                productGram={productGram}
                setProductGram={setProductGram}
                filterProducts={filterProducts}
              />
            </CustomDropdown>
            <CustomDropdown
              trigger={`Carat (CT) ${productCarat[0]}-${productCarat[1]}`}
              customClass="carat_filter"
            >
              <CaratRangeFilter
                productCarat={productCarat}
                setProductCarat={setProductCarat}
                filterProducts={filterProducts}
              />
            </CustomDropdown>
            <div
              style={{ display: "flex", alignItems: "center", gap: "10px" }}
              className="mobile_show"
            >
              <span>
                <CustomCheckbox
                  checked={sendCustomData}
                  onCheckedChange={setSendCustomData}
                  onChecked={() => {
                    if (!firstChecked.current) {
                      setFilterModal(true);
                      firstChecked.current = true;
                    } else {
                      setProductData([]);
                      setPageOffSet(1);
                      getProducts(null, true);
                    }
                  }}
                  onUnchecked={() => {
                    setProductData([]);
                    setPageOffSet(1);
                    getProducts(null, false);
                  }}
                />
              </span>
              <button
                className="filter_button"
                onClick={() => setFilterModal(true)}
              >
                My Diamonds
              </button>
            </div>
            <button className="reset_btn" onClick={resetFilters}>
              Reset
            </button>
          </div>

          <div className="filter_right_con">
            <span className="desktop_show">
              <CustomCheckbox
                checked={sendCustomData}
                onCheckedChange={setSendCustomData}
                onChecked={() => {
                  if (!firstChecked.current) {
                    setFilterModal(true);
                    firstChecked.current = true;
                  } else {
                    setProductData([]);
                    setPageOffSet(1);
                    if (pageOffSet === 1) {
                      getProducts(null, true);
                    }
                  }
                }}
                onUnchecked={() => {
                  setProductData([]);
                  setPageOffSet(1);
                  if (pageOffSet === 1) {
                    getProducts(null, false);
                  }
                }}
              />
            </span>
            <button
              className="filter_button desktop_show"
              onClick={() => setFilterModal(true)}
            >
              My Diamonds
            </button>
            <CustomSelect
              options={sortingOptions}
              value={sortOrder}
              onChange={(value) => setSortOrder(value)}
              placeholder="Sort By"
              icon={<RxCaretSort size="22px" color="#000" />}
            />
          </div>
        </div>
      )} */}
    </>
  );
};

export default ShopTopActionFilter;
